import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { BrandProductSpotlight } from "@faire/retailer-visitor-shared/components/BrandProductSpotlight/index";
import { getProductSpotlightCards } from "@faire/retailer-visitor-shared/components/BrandProductSpotlight/utils";
import { getSettingUpdatedNAMCommissionAnnouncement } from "@faire/retailer-visitor-shared/settings/getSettingUpdatedNAMCommissionAnnouncement";
import { ACCORDION_ITEMS, commissionUpdateNAMAccordionItems } from "@faire/retailer-visitor-shared/views/brands/landing-page/BrandsLandingPageFAQs";
import { BrandsLandingPageNews } from "@faire/retailer-visitor-shared/views/brands/landing-page/BrandsLandingPageNews";
import { StyledSellOnFaireButton, CTAPosition, getIsShowingCaseStudies } from "@faire/retailer-visitor-shared/views/brands/landing-page/const";
import { QuestionAccordion } from "@faire/retailer-visitor-shared/views/brands/landing-page/QuestionAccordion";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Accordion } from "@faire/web--source/slate/Accordion";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackBrandLeadsApplyToSellOnFaireClick } from "@faire/web-api--source/events/brandLeads/click/applyToSellOnFaire";
import { trackBrandLeadsBrandsPageQandaClick } from "@faire/web-api--source/events/brandLeads/click/brandsPageQanda";
import { trackBrandLeadsScheduleACallClick } from "@faire/web-api--source/events/brandLeads/click/scheduleACall";
import { trackBrandLeadsBrandPageBrandsQnaSectionView } from "@faire/web-api--source/events/brandLeads/view/brandPageBrandsQnaSection";
import { trackBrandLeadsBrandsPageBottomSectionView } from "@faire/web-api--source/events/brandLeads/view/brandsPageBottomSection";
import { trackBrandLeadsBrandsPageSpotlightCarouselView } from "@faire/web-api--source/events/brandLeads/view/brandsPageSpotlightCarousel";
import { trackBrandLeadsNewsSectionView } from "@faire/web-api--source/events/brandLeads/view/newsSection";
import { observer } from "mobx-react";
import React, { useCallback, useState } from "react";
import styled, { css } from "styled-components";
var BrandsLandingPageBottomSectionBase = function(param) {
    var onButtonClick = param.onButtonClick, calendlyLink = param.calendlyLink, isPersonalized = param.isPersonalized;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var viewport = useViewport();
    var _useState = _sliced_to_array(useState(viewport.isMobile ? undefined : 0), 2), openIndex = _useState[0], setOpenIndex = _useState[1];
    var actionWhenSpotlightVisibleHandler = useCallback(function() {
        var _getProductSpotlightCards_;
        var key = (_getProductSpotlightCards_ = getProductSpotlightCards(strictLocalize)[0]) === null || _getProductSpotlightCards_ === void 0 ? void 0 : _getProductSpotlightCards_.eventKey;
        if (key) {
            trackBrandLeadsBrandsPageSpotlightCarouselView(key);
        }
    }, [
        strictLocalize
    ]);
    var toggleAccordionItem = function(index) {
        if (openIndex === index) {
            setOpenIndex(undefined);
        } else {
            var _commissionUpdateNAMAccordionItems_index, _ACCORDION_ITEMS_index;
            var eventKey = getSettingUpdatedNAMCommissionAnnouncement() ? (_commissionUpdateNAMAccordionItems_index = commissionUpdateNAMAccordionItems(strictLocalize)[index]) === null || _commissionUpdateNAMAccordionItems_index === void 0 ? void 0 : _commissionUpdateNAMAccordionItems_index.eventKey : (_ACCORDION_ITEMS_index = ACCORDION_ITEMS(strictLocalize)[index]) === null || _ACCORDION_ITEMS_index === void 0 ? void 0 : _ACCORDION_ITEMS_index.eventKey;
            if (eventKey) {
                trackBrandLeadsBrandsPageQandaClick(eventKey);
            }
            setOpenIndex(index);
        }
    };
    var bottomBannerViewRef = useDoActionWhenVisible(trackBrandLeadsBrandsPageBottomSectionView);
    return /*#__PURE__*/ _jsxs(WhenVisibilityIsImminent, {
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ _jsx(BrandProductSpotlight, {
                        onView: actionWhenSpotlightVisibleHandler,
                        isPersonalized: isPersonalized,
                        showCaseStudies: getIsShowingCaseStudies()
                    }),
                    /*#__PURE__*/ _jsx(FAQWrapper, {
                        $showCaseStudies: getIsShowingCaseStudies(),
                        children: /*#__PURE__*/ _jsx(Row, {
                            style: {
                                width: "100%",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ _jsx(Column, {
                                style: {
                                    width: "700px"
                                },
                                justify: "center",
                                align: viewport.isMobile ? "flex-start" : "center",
                                children: getSettingUpdatedNAMCommissionAnnouncement() ? /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            size: viewport.isMobile ? "3x" : "9x"
                                        }),
                                        /*#__PURE__*/ _jsx(Accordion, {
                                            items: commissionUpdateNAMAccordionItems(strictLocalize)
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            size: viewport.isMobile ? 0 : "10x"
                                        })
                                    ]
                                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            size: viewport.isMobile ? "4x" : 88
                                        }),
                                        /*#__PURE__*/ _jsx(Header, {
                                            variant: {
                                                mobileAndAbove: "pageHeaderSerifRegular",
                                                tabletAndAbove: "displayMSerifRegular",
                                                desktopAndAbove: "displayLSerifRegular"
                                            },
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "g9j62C",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "You may be wondering..."
                                                    }
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            size: viewport.isMobile ? "1x" : "6x"
                                        }),
                                        /*#__PURE__*/ _jsx(Row, {
                                            justify: "center",
                                            children: /*#__PURE__*/ _jsx(QuestionAccordion, {
                                                onView: trackBrandLeadsBrandPageBrandsQnaSectionView,
                                                information: ACCORDION_ITEMS(strictLocalize),
                                                openIndex: openIndex,
                                                onItemClick: toggleAccordionItem
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            size: viewport.isMobile ? "2x" : "10x"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(BrandsLandingPageNews, {
                onView: trackBrandLeadsNewsSectionView
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: bottomBannerViewRef,
                children: viewport.isMobile ? /*#__PURE__*/ _jsx(BottomBannerMobile, {
                    onButtonClick: onButtonClick,
                    isPersonalized: isPersonalized,
                    calendlyLink: calendlyLink
                }) : /*#__PURE__*/ _jsx(BottomBannerDesktop, {
                    onButtonClick: onButtonClick,
                    isPersonalized: isPersonalized,
                    calendlyLink: calendlyLink
                })
            })
        ]
    });
};
var BottomBannerDesktopBase = function(param) {
    var onButtonClick = param.onButtonClick, calendlyLink = param.calendlyLink, isPersonalized = param.isPersonalized;
    var viewport = useViewport();
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsxs(Column, {
        style: {
            width: "100%",
            position: "relative"
        },
        justify: "center",
        children: [
            /*#__PURE__*/ _jsx(BackgroundImage, {
                src: optimizeImageUrl({
                    url: "https://cdn.faire.com/fastly/5f577365c2721dea3f28c5857027c1637a2a9971c5a7a431acdedae0951b2255.png"
                }, isSSR, {
                    width: 2560
                })
            }),
            /*#__PURE__*/ _jsx(Row, {
                style: {
                    width: "100%"
                },
                justify: "center",
                children: /*#__PURE__*/ _jsx(StyledTypography, {
                    variant: viewport.isDesktopAndAbove ? "displayLSerifRegular" : "displayMSerifRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "JTvuCw",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Ready to grow your wholesale business?"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Row, {
                style: {
                    width: "100%"
                },
                justify: "center",
                children: isPersonalized && calendlyLink ? /*#__PURE__*/ _jsx(StyledSellOnFaireButton, {
                    linkTo: calendlyLink,
                    target: "_blank",
                    onClick: function() {
                        trackBrandLeadsScheduleACallClick(CTAPosition.BOTTOM_SECTION);
                    },
                    style: {
                        position: "absolute",
                        top: viewport.isTablet ? 180 : 300
                    },
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "ohZEk7",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Schedule a Call"
                            }
                        ]
                    })
                }) : /*#__PURE__*/ _jsx(StyledSellOnFaireButton, {
                    onClick: function() {
                        trackBrandLeadsApplyToSellOnFaireClick(CTAPosition.BOTTOM_SECTION);
                        onButtonClick();
                    },
                    style: {
                        position: "absolute",
                        top: viewport.isTablet ? 180 : 300
                    },
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "Ty79wp",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Get started"
                            }
                        ]
                    })
                })
            })
        ]
    });
};
var BottomBannerDesktop = observer(BottomBannerDesktopBase);
var BottomBannerMobileBase = function(param) {
    var onButtonClick = param.onButtonClick, calendlyLink = param.calendlyLink, isPersonalized = param.isPersonalized;
    return /*#__PURE__*/ _jsxs(Column, {
        style: {
            width: "100%",
            backgroundColor: Decorative.shade.yellow,
            padding: getSpacing("4x")
        },
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.inverse,
                variant: "displaySSerifRegular",
                align: "left",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "qOcrLv",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Ready to see your products in stores around the world?"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "4x"
            }),
            /*#__PURE__*/ _jsx(Row, {
                style: {
                    width: "100%"
                },
                justify: "center",
                children: isPersonalized && calendlyLink ? /*#__PURE__*/ _jsx(Button, {
                    variant: "secondary",
                    linkTo: calendlyLink,
                    target: "_blank",
                    onClick: function() {
                        trackBrandLeadsScheduleACallClick(CTAPosition.BOTTOM_SECTION);
                    },
                    style: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "ohZEk7",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Schedule a Call"
                            }
                        ]
                    })
                }) : /*#__PURE__*/ _jsx(Button, {
                    variant: "secondary",
                    style: {
                        width: "100%"
                    },
                    onClick: function() {
                        trackBrandLeadsApplyToSellOnFaireClick(CTAPosition.BOTTOM_SECTION);
                        onButtonClick();
                    },
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "nga/6k",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Get Started"
                            }
                        ]
                    })
                })
            })
        ]
    });
};
var BottomBannerMobile = observer(BottomBannerMobileBase);
export var BrandsLandingPageBottomSection = observer(BrandsLandingPageBottomSectionBase);
var Header = styled(Typography).withConfig({
    componentId: "sc-dd9720c6-0"
})([
    "&&&{",
    "{margin-left:",
    ";}}"
], responsiveMediaQueries.mobile, getSpacing("3x"));
var BackgroundImage = styled.img.withConfig({
    componentId: "sc-dd9720c6-1"
})([
    "width:100%;",
    "{height:430px;}",
    "{height:260px;}",
    "{height:300px;}"
], responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.tablet, responsiveMediaQueries.mobile);
var StyledTypography = styled(Typography).attrs({
    align: "center",
    color: "white"
}).withConfig({
    componentId: "sc-dd9720c6-2"
})([
    "",
    "{top:65px;position:absolute;}",
    "{top:110px;position:absolute;}"
], responsiveMediaQueries.tablet, responsiveMediaQueries.desktopAndAbove);
var FAQWrapper = styled(Column).attrs({
    justify: "center"
}).withConfig({
    componentId: "sc-dd9720c6-3"
})([
    "width:100%;",
    "{",
    "}"
], responsiveMediaQueries.tabletAndAbove, function(param) {
    var $showCaseStudies = param.$showCaseStudies;
    return $showCaseStudies ? css([
        "background-color:",
        ";"
    ], Decorative.tint.neutral) : null;
});
